import type { IconNode } from '../types';

/**
 * @name goblet-crack
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNOCAyYy0xLjc4IDIuNzItMyA2LjY1LTMgOWE3IDcgMCAxIDAgMTQgMGMwLTIuMzUtMS4yMi02LjI4LTMtOVoiIC8+CiAgPHBhdGggZD0iTTEyIDE4djQiIC8+CiAgPHBhdGggZD0iTTggMjJoOCIgLz4KICA8cGF0aCBkPSJtMTMgMTEtMS0xIDItMi0zLTMgMy0zIiAvPgo8L3N2Zz4K) - https://lucide.dev/icons/goblet-crack
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const gobletCrack: IconNode = [
  ['path', { d: 'M8 2c-1.78 2.72-3 6.65-3 9a7 7 0 1 0 14 0c0-2.35-1.22-6.28-3-9Z', key: '11c6l5' }],
  ['path', { d: 'M12 18v4', key: 'jadmvz' }],
  ['path', { d: 'M8 22h8', key: 'rmew8v' }],
  ['path', { d: 'm13 11-1-1 2-2-3-3 3-3', key: 'tia1xx' }],
];

export default gobletCrack;
